import React, { useEffect, useState, useRef } from "react";

import "./RedirectModal.css";

import SmallCaption from "../small-caption/SmallCaption";
import SectionHeader from "../section-header/SectionHeader";
import Link from "../link/Link";

import { ASTRONAUT_SINGLE } from "../../_media/assets";
import createAnimation from "../../_utils/createAnimation";

const CORRECT_LINK = "https://www.claritypsychotherapycounseling.com/"

const RedirectModal = () => {
  const [secondsLeft, setSecondsLeft] = useState(10);
  const ref = useRef(null);

  const decrementSecond = () => {
    const timer = setTimeout(() => {
      if (secondsLeft === 1) {
        const anchor = document.createElement('a')
        anchor.href = CORRECT_LINK
        document.body.appendChild(anchor)
        anchor.click()
      } else {
        setSecondsLeft(seconds => seconds-1);
      }
      clearTimeout(timer)
    }, 1000);
  }
  
  useEffect(() => createAnimation(ref), []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => decrementSecond(), [secondsLeft]);

  return (
    <section className="RedirectModal" ref={ref}>
      <SmallCaption text="We moved" />
      <SectionHeader text="We are now Clarity Psychotherapy!" />
      <SmallCaption text={`Redirecting in ${secondsLeft} seconds...`} />
      <Link link={CORRECT_LINK} primary>Or Click Here</Link>
      <img src={ASTRONAUT_SINGLE} className="RedirectModal-img" alt="" />
    </section>
  )
}

export default RedirectModal;